import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LoggerService } from '../services/logger.service';

export const authGuard = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  const isAuthenticated = await authService.isAuthenticated();
  logger.debug('[AuthGuard] isAuthenticated:', isAuthenticated);

  if (isAuthenticated) {
    logger.debug('[AuthGuard] Access granted');
    return true;
  }

  logger.warn('[AuthGuard] Not authenticated, redirecting to /login');
  return router.parseUrl('/login');
};
